import { Tooltip } from '@/components/lemmala-design-system/tooltip/tooltip'

import { StringNameAvatar } from './string-name-avatar'
import { type AvatarListSize } from './types'
import { avatarRingVariants } from './variants'

type AvatarWithTooltipProps = {
  name: string
  size: AvatarListSize
}

export const AvatarWithTooltip = ({ name, size }: AvatarWithTooltipProps) => {
  return (
    <Tooltip
      content={name}
      trigger={
        <StringNameAvatar name={name} size={size} className={avatarRingVariants({ size })} />
      }
    >
      {name}
    </Tooltip>
  )
}
